export interface Testimonial {
  initials: string
  name: string
  role: string
  text: string
}

/**
 * Placeholders — replace with verified customer reviews before publishing.
 */
export const featuredTestimonials: Testimonial[] = [
  {
    initials: 'R1',
    name: 'Review 1',
    role: 'Verified customer review',
    text: 'Add a real testimonial about saving planning time.',
  },
  {
    initials: 'R2',
    name: 'Review 2',
    role: 'Verified customer review',
    text: 'Add a real testimonial about the session structure.',
  },
  {
    initials: 'R3',
    name: 'Review 3',
    role: 'Verified customer review',
    text: 'Add a real testimonial about drills and corrections.',
  },
]

export const extendedTestimonials: Testimonial[] = [
  ...featuredTestimonials,
  {
    initials: 'R4',
    name: 'Review 4',
    role: 'Verified customer review',
    text: 'Add a real testimonial about confidence in the gym.',
  },
  {
    initials: 'R5',
    name: 'Review 5',
    role: 'Verified customer review',
    text: 'Add a real testimonial about athlete engagement or progression.',
  },
]
